<div class="modal-header">
  <h4 class="modal-title heading-5" id="modal-basic-title">
    {{ (editing ? "expenses.edit" : "expenses.create") | translate }}
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body p-3">
  <!-- <div class="row">
    <div class="col-12">
      <app-create-travel-modal
        [customBooking]="true"
        [userUuid]="userUuid"
        (sendInfo)="handleTravel($event)"
      >
      </app-create-travel-modal>
    </div>
  </div> -->
  <form
    [formGroup]="form"
    [ngClass]="{ 'loading-background': loading }"
    (ngSubmit)="form.valid && !loading ? onSubmit() : (isInvalid = true)"
  >
    <div class="row mt-0"
      *ngIf="editing && (userType?.toLowerCase() === 'employee' || userType?.toLowerCase() === 'company')">
      <div class="col-12">
        <div class="form-group passenger-select">
          <label class="pt-0" for="passenger">{{ "common.traveller" | translate }}</label>

          <mat-select
            id="passenger"
            formControlName="passenger"
            class="form-control custom-select"
            (openedChange)="!$event && resetUsersFilter()"
          >
            <mat-option class="search-option" disabled>
              <input
                class="custom-mat-input"
                matInput
                (input)="applyFilter($event.target.value)"
                (click)="$event.stopPropagation()"
                placeholder="{{ 'common.search-user' | translate }}"
              />
            </mat-option>

            <mat-option *ngFor="let user of filteredUsers" [value]="user.uuid">
              {{ user.name }} {{ user.lastname }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group input-file">
            <input
              formControlName="file"
              type="file"
              id="file"
              class="inputFile"
              (change)="onFileChange($event)"
              accept="application/pdf"
              multiple
            />
            <label for="file" class="px-3 py-1 labelFile" [class.disabled]="userType !== 'EMPLOYEE'">{{
              "common.choose-file" | translate
            }}</label>
            <div class="file-tags" *ngIf="(files?.length > 0 || existingFiles?.length > 0); else showFileBack">
              <span *ngFor="let f of existingFiles; let i = index" class="file-tag">
                {{ f.name }}
                <button type="button" class="remove-btn" (click)="removeFile(i)">x</button>
              </span>
              <span *ngFor="let f of files; let i = index" class="file-tag">
                {{ f.name }}
                <button type="button" class="remove-btn" (click)="removeFile(i)">x</button>
              </span>
            </div>
            <ng-template #showFileBack>
              <label class="pl-3" *ngIf="fileBack">
                {{ fileBack.name }}
              </label>
            </ng-template>
          </div>
      </div>
      <div class="col-6 checkbox">
        <mat-checkbox
          class="example-margin"
          [formControl]="form.controls['freeTaxes']"
        >
          <small>{{ "expenses.freeTaxes" | translate }}</small>
        </mat-checkbox>
      </div>
    </div>

    <div class="row" style="margin-top: 2rem;" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group">
          <div>
            <label>{{ 'expenses.type' | translate }}</label>
            <input
              formControlName="type"
              placeholder="{{ 'expenses.type' | translate }}"
              type="text"
              id="type"
              class="form-control"
              [ngClass]="{
                'input-error':
                  !form.controls.type.valid && isInvalid
              }"
            />
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12">
        <label>{{ 'my-bookeds.view.provider' | translate }}</label>
        <mat-form-field style="font-size: small;" appearance="fill" class="full-width travellers no-bottom">
          <mat-select
            formControlName="provider"
            [compareWith]="providerCompare"
            [disabled]="loadingExpenseProviders"
            placeholder="{{ 'my-bookeds.view.provider' | translate }}">

            <mat-option *ngIf="!loadingExpenseProviders && !expenseProviderOptions.length" disabled>
              {{ "common.no-providers-available" | translate }}
            </mat-option>

            <mat-option *ngFor="let opt of expenseProviderOptions" [value]="opt.uuid">
              {{ opt.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'company.company-booked.wholesale-price' | translate }}</label>
          <input
            formControlName="wholesalePrice"
            placeholder="{{ 'company.company-booked.wholesale-price' | translate }}"
            type="text"
            id="wholesalePrice"
            class="form-control"
            [ngClass]="{
              'input-error':
                !form.controls.wholesalePrice.valid &&
                isInvalid &&
                !form.controls.wholesalePrice.disabled
            }"
          />
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'expenses.price' | translate }}</label>
          <input
              formControlName="price"
              placeholder="{{ 'expenses.price' | translate }}"
              type="text"
              id="price"
              [readonly]="expense && expense.amount"
              class="form-control"
              [ngClass]="{
                'input-error':
                  !form.controls.price.valid && isInvalid && !form.controls.price.disabled
              }"
            />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-12">
        <div class="form-group">
          <label>{{ 'expenses.extras-title' | translate }}</label>
          <textarea
            formControlName="annotationsExtras"
            rows="3"
            class="form-control"
            placeholder="{{ 'expenses.extras-field' | translate }}"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'authorization.labels.from' | translate }}</label>
          <div class="form-group d-flex align-items-center">
            <div class="input-group">
              <input
                [disabled]="this.userType != 'EMPLOYEE'"
                id="date_form"
                class="form-control filter-dates-placeholder"
                readonly
                placeholder="{{ 'authorization.labels.from' | translate }}"
                name="dpInput"
                formControlName="beginDate"
                ngbDatepicker
                #dInput="ngbDatepicker"
                (click)="dInput.toggle()"
                [maxDate]="getOutMaxDate()"
                [ngClass]="{
                  'input-error':
                    !form.controls.beginDate.valid && isInvalid
                }"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label>{{ 'authorization.labels.to' | translate }}</label>
          <div class="input-group">
            <input
              [disabled]="this.userType != 'EMPLOYEE'"
              id="date_to"
              class="form-control filter-dates-placeholder"
              readonly
              placeholder="{{ 'authorization.labels.to' | translate }}"
              name="dpOutput"
              formControlName="endDate"
              ngbDatepicker
              #dOutput="ngbDatepicker"
              (click)="dOutput.toggle()"
              [minDate]="getOutMinDate()"
              [ngClass]="{
                'input-error':
                  !form.controls.endDate.valid && isInvalid
              }"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="form-group">
          <label>{{ 'common.custom-code' | translate }}</label>
          <input
            formControlName="customCode"
            placeholder="{{ 'common.custom-code' | translate }}"
            type="text"
            id="customCode"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12">
        <div class="form-group">
          <label>{{ 'common.cost-center' | translate }}</label>
          <input
            formControlName="costCenter"
            placeholder="{{ 'common.cost-center' | translate }}"
            type="text"
            id="costCenter"
            class="form-control"
          />
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center;">
        <div class="form-group" style="width: 100% !important;">
          <label>{{ 'company.bills.supplier-invoice' | translate }}</label>
          <input
            formControlName="supplierInvoice"
            placeholder="{{ 'company.bills.supplier-invoice' | translate }}"
            type="text"
            id="supplierInvoice"
            class="form-control"
          />
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center; padding-bottom: 1rem;">
        <div class="form-group" style="width: 100% !important;">
          <label>{{ 'company.company-booked.booking-type' | translate }}</label>
          <mat-form-field appearance="fill"
                          class="full-width travellers booktype-compact"
                          floatLabel="never">
            <mat-select formControlName="bookType"
                        [disabled]="loading"
                        placeholder="{{ 'company.company-booked.booking-type' | translate }}">
              <mat-option value="automatic">{{ 'common.automatic-book' | translate }}</mat-option>
              <mat-option value="semiautomatic">{{ 'common.semiautomatic-book' | translate }}</mat-option>
              <mat-option value="manual">{{ 'common.manual-book' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-lg-6 col-md-6 col-xs-12" style="display: flex; align-items: center; padding-bottom: 1rem;">
        <div class="form-group" style="width: 100% !important;">
          <label>{{ 'company.company-booked.invoiced-status' | translate }}</label>
          <mat-form-field
            appearance="fill"
            class="full-width travellers booktype-compact"
            floatLabel="never"
          >
            <mat-select
              formControlName="invoiced"
              [disabled]="loading"
              placeholder="{{ 'company.company-booked.invoiced-status' | translate }}"
            >
              <mat-option value="none">
                {{ 'company.company-booked.invoiced-none' | translate }}
              </mat-option>
              <mat-option value="invoiced">
                {{ 'company.company-booked.invoiced-invoiced' | translate }}
              </mat-option>
              <mat-option value="proforma">
                {{ 'company.company-booked.invoiced-proforma' | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-12">
        <div class="form-group">
          <label>{{ 'expenses.comments-title' | translate }}</label>
          <textarea
            formControlName="comments"
            rows="3"
            class="form-control"
            placeholder="{{ 'expenses.comments-field' | translate }}"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="userType === 'EMPLOYEE'">
      <div class="col-12">
        <div class="form-group">
          <label>{{ 'expenses.adminComments-title' | translate }}</label>
          <textarea
            formControlName="adminComments"
            rows="3"
            class="form-control"
            placeholder="{{ 'expenses.adminComments-field' | translate }}"
          ></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-flex justify-content-end">
          <button
            class="custom-btn mb-0"
            ngbAutofocus
            mat-button
            [ngStyle]="{
              cursor:
                !form.valid || loading ? 'not-allowed' : 'pointer'
            }"
            [ngClass]="{
              'disabled-button': !form.valid || loading
            }"
          >
            {{ "common.send" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
  <div class="row" *ngIf="loading">
    <app-loading [userType]="'employee'"></app-loading>
  </div>
</div>
